export const privateRoute = (path: string) => {
  return path === '/declaration-sinistre' || path === '/confirmation-sinistre' || path === '/redirect';
};
